import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Sidebar from "../../SideComponents/BlogsSidebar";
import Styles from "../../../assets/css/Blogs/ProblemSolving/HostingDomainSolution.module.css";
import debounce from "lodash.debounce"; // lodash.debounce , It will Add delay to observer that can help stoping the flickerings
import { Helmet } from "react-helmet-async";

// Global States imports
import { useGlobalState } from "../../../Functions/GlobalStates";

const HostingDomainSolution = () => {
  // This Id Will Help Get Likes & Views Of This Problem⬇️
  const questionId = "3"; // Replace with dynamic question ID
  const [likes, setLikes] = useState(0); // State to hold the number of likes
  const [Views, setViews] = useState(0); // State to hold the number of likes
  // Global States
  const { PagesWidthHeight, setPagesWidthHeight } = useGlobalState();
  // React useRef Refferences
  const CheckHostingDomainSolutionSize = useRef(false);

  // Fetching images
  // const HostingDomainSolutionSolutionImages = require.context(
  //   "../../../assets/images/Blogs/HostingDomainSolution", // Path to the directory
  //   false, // Do not include subdirectories (set to true if you want to include them)
  //   /\.(png|PNG|jpg|jpeg|webp|svg)$/ // Regular expression to match file types
  // );
  // const SolutionImages = [
  // HostingDomainSolutionSolutionImages("./screen1.png"), // Dynamically load the image
  // HostingDomainSolutionSolutionImages("./screen2.png"), // Dynamically load the image
  // HostingDomainSolutionSolutionImages("./screen3.png"), // Dynamically load the image
  // HostingDomainSolutionSolutionImages("./screen4.png"), // Dynamically load the image
  // HostingDomainSolutionSolutionImages("./screen5.png"), // Dynamically load the image
  // ];

  // updating height to modify sidebar height
  useEffect(() => {
    const updateSize = () => {
      const { height } =
        CheckHostingDomainSolutionSize.current.getBoundingClientRect();
      setPagesWidthHeight((prev) => ({
        ...prev,
        height: parseFloat(height.toFixed(1)),
      }));
      // console.log("Heigth", height);
    };

    updateSize(); // Run once on mount
    // Debounce Will Help Derease the Consuption of the Ram & Limit Bulk re-Runing Funtions in a Sec
    const updateSizeDelay = debounce(updateSize, 100);
    window.addEventListener("resize", updateSize);
    window.addEventListener("scroll", updateSizeDelay);

    // Cleanup function to remove event listener when component unmounts
    return () => {
      window.removeEventListener("resize", updateSize);
      window.removeEventListener("scroll", updateSizeDelay);
    };
  }, []);

  // Fetch Likes From Database
  useEffect(() => {
    const AllViews = async () => {
      const hasViewed = localStorage.getItem(`viewed_${questionId}`); // Check if user has already viewed this question

      try {
        if (hasViewed) {
          // alert("You have already Viewed this question.");
          // Fetching the current view data
          const ViewsResponse = await axios.get(
            `https://affiliators.netlify.app/.netlify/functions/server/api/getviews/${questionId}`
          );
          if (ViewsResponse.data && ViewsResponse.data.views !== undefined) {
            setViews(ViewsResponse.data.views); // Update the state with the number of views
            // alert('Thank you for Viewing the question!');
          } else {
            console.error("No view data received from the get req and server");
          }
        } else {
          // Sending PUT request to the server to update or create the view count
          const ViewsResponse = await axios.put(
            `https://affiliators.netlify.app/.netlify/functions/server/api/views/${questionId}`
          );

          if (ViewsResponse.data && ViewsResponse.data.views !== undefined) {
            setViews(ViewsResponse.data.views); // Update the state with the number of views
            localStorage.setItem(`viewed_${questionId}`, "true"); // Mark as viewed in localStorage
            // alert("Thank you for Viewing the question!");
          } else {
            console.error("No view data received from the put req and server");
          }
        }
      } catch (error) {
        console.error("Error updating views:", error.message);

        // Check if the error is due to the document not being found
        if (error.response && error.response.status === 404 && !hasViewed) {
          // Retry by invoking GET request to create the data if missing
          try {
            // Retry the GET request only if the user has not viewed yet
            const retryResponse = await axios.get(
              `https://affiliators.netlify.app/.netlify/functions/server/api/getviews/${questionId}`
            );
            if (retryResponse.data && retryResponse.data.views !== undefined) {
              setViews(retryResponse.data.views); // Update state with the number of views
              // alert("Thank you for Viewing the question!");
            } else {
              console.error("No view data received from the retry GET request");
            }
          } catch (retryError) {
            console.error("Error on retrying GET request:", retryError.message);
            // alert("Error retrying to fetch view data. Please try again later.");
          }
        } else {
          // alert("Error updating views. Please try again later.");
        }
      }
    };

    AllViews();

    const fetchOrAddLikes = async () => {
      try {
        const fetchresponse = await axios.get(
          `https://affiliators.netlify.app/.netlify/functions/server/api/checklikes/${questionId}`
        ); // Fetch or create likes
        setLikes(fetchresponse.data.likes); // Update state with the number of likes
      } catch (error) {
        console.error("Error fetching or adding likes:", error.message);
      }
    };

    fetchOrAddLikes();
  }, []);

  const HandleLike = async () => {
    const hasLiked = localStorage.getItem(`liked_${questionId}`); // Check if user has liked the question

    if (hasLiked) {
      // alert("You have already liked this question.");
      return;
    }
    try {
      const response = await axios.put(
        `https://affiliators.netlify.app/.netlify/functions/server/api/updatelikes/${questionId}`
      ); // Send request to backend
      setLikes(response.data.likes); // Update the likes state with the latest count

      // Store in localStorage to prevent multiple likes
      localStorage.setItem(`liked_${questionId}`, "true");
      // alert("Thank you for liking the question!");
    } catch (error) {
      console.error("Error updating likes:", error.message);
    }
  };

  const SidebarProps = {
    RTL1: "https://2stallions.com/blog/troubleshooting-common-web-hosting-problems/",
    RTL2: "https://www.upguard.com/blog/domain-name-registrar",
    RTL3: "https://www.hostinger.com/tutorials/ssl-benefits?utm_medium=ppc&utm_campaign=Generic-Tutorials-DSA|NT:Se|LO:PK&gad_source=1&gclid=CjwKCAiA5Ka9BhB5EiwA1ZVtvNbtsu8KWrqCVAXmEmKFkLgRblZWfOsK4uJbHFjTCFsabQHqVENbpRoCUZ4QAvD_BwE",
    RTL4: "https://www.hostinger.com/tutorials/what-is-cloud-hosting?utm_medium=ppc&utm_campaign=Generic-Tutorials-DSA|NT:Se|LO:PK-t2&gad_source=1&gclid=CjwKCAiA5Ka9BhB5EiwA1ZVtvPtWAOGZ1OORnK1MqnmRR3_0bU83i2Fj1J7hfzHtO62msjvl-bZKqRoCCyAQAvD_BwE",
    RTL5: "https://www.cloudways.com/blog/what-is-server-management/",
    RTL6: "https://www.seo.com/blog/why-is-my-website-slow/",
    RTC1: "Web hosting",
    RTC2: "Domain registration",
    RTC3: "SSL security",
    RTC4: "Cloud hosting",
    RTC5: "Server management",
    RTC6: "Website speed",
  };

  return (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Best Hosting and Domain Solutions 🌐</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Discover how to choose the best hosting and domain solutions for your website. Learn about different types, features, and essential tips."
        />

        {/* Keywords for SEO */}
        <meta
          name="keywords"
          content="hosting solutions, domain selection, website hosting, VPS, shared hosting, domain registration"
        />

        {/* Responsive Design */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph Meta Tags for Social Sharing */}
        <meta
          property="og:title"
          content="Best Hosting and Domain Solutions 🌐"
        />
        <meta
          property="og:description"
          content="Discover how to choose the best hosting and domain solutions for your website. Learn about different types, features, and essential tips."
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://affiliators.netlify.app/#/problemsolving/hostingdomainsolution"
        />
        {/* <meta
          property="og:image"
          content="/images/HostingDomainSolution/hosting1.png"
        /> */}

        {/* Twitter Meta Tags for Social Sharing */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Best Hosting and Domain Solutions 🌐"
        />
        <meta
          name="twitter:description"
          content="Discover how to choose the best hosting and domain solutions for your website. Learn about different types, features, and essential tips."
        />
        {/* <meta
          name="twitter:image"
          content="/images/HostingDomainSolution/hosting1.png"
        /> */}

        {/* Robots Meta Tag */}
        <meta name="robots" content="index, follow" />

        {/* Canonical URL */}
        {/* <link
          rel="canonical"
          href="https://affiliators.netlify.app/#/problemsolving/hostingdomainsolution"
        /> */}

        {/* Additional Meta Tags */}
        <meta name="author" content="Zeeshan Ahmad Kamran" />
        <meta name="language" content="en" />
        <meta http-equiv="Content-Language" content="en" />
      </Helmet>
      <div className={Styles.BlogSidebarHostingDomainSolutionContainer}>
        <Sidebar {...SidebarProps} />
        <div
          ref={CheckHostingDomainSolutionSize}
          className={Styles.HostingDomainSolutionContainer}
        >
          <section className={Styles.HostingDomainSolutionSection1Container}>
            <div
              className={
                Styles.HostingDomainSolutionSection1QuestionLikesViewsContainer
              }
            >
              <h4>Problem</h4>
              <h1>Choosing the Right Hosting & Domain Solutions.</h1>
              <div
                className={
                  Styles.HostingDomainSolutionSection1LikesViewsContainer
                }
              >
                <button
                  className={Styles.LikeButton}
                  onClick={HandleLike}
                  aria-label="Like this question"
                >
                  👍🏻 {likes}
                </button>
                <span>{Views} Views</span>
              </div>
            </div>
          </section>
          <section className={Styles.HostingDomainSolutionSection2Container}>
            <div
              className={Styles.HostingDomainSolutionSection2AnswerContainer}
            >
              <h4>Solution</h4>
              <p>Follow These Steps:</p>
              <h3>Step No. 1 ....</h3>
              <p>Watch this video:</p>
              <iframe
                className={Styles.HostingDomainSolutionSection2AnswerVideo1}
                src="https://www.youtube.com/embed/0CwWkv9QFFI?si=KVMBO8tSDfw3FLk2"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
              <p>
                If the following video solved your problem, feel free to skip
                the remaining steps. If not, continue with the next steps ⬇️
              </p>
              <h3>Step 2: Identify Your Website Needs</h3>
              {/* <h3>For Windows Users</h3> */}
              <div
                className={
                  Styles.HostingDomainSolutionSection2AnswerImagesContainer
                }
              >
                <div
                  className={
                    Styles.HostingDomainSolutionSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Determine the type of website (blog, e-commerce,
                    portfolio, etc.).
                  </p>
                  {/* <img src={SolutionImages[0]} alt="loding step 2" /> */}
                </div>
                <div
                  className={
                    Styles.HostingDomainSolutionSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Consider traffic expectations and storage requirements.
                  </p>
                  {/* <img src={SolutionImages[2]} alt="loding step 2" /> */}
                </div>
                <div
                  className={
                    Styles.HostingDomainSolutionSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Decide between shared, VPS, dedicated, or cloud hosting.
                  </p>
                  {/* <img src={SolutionImages[1]} alt="loding step 3" /> */}
                </div>
              </div>
              <h3>Step 3: Choose a Reliable Hosting Provider</h3>
              <div
                className={
                  Styles.HostingDomainSolutionSection2AnswerImagesContainer
                }
              >
                <div
                  className={
                    Styles.HostingDomainSolutionSection2AnswerImgContainer
                  }
                >
                  <p>👉🏻 Look for 99.9% uptime and fast server speeds.</p>

                  <p>
                    👉🏻 Ensure 24/7 customer support and strong security
                    features.
                  </p>
                  {/* <img src={SolutionImages[3]} alt="loding step 2" /> */}
                </div>
                <div
                  className={
                    Styles.HostingDomainSolutionSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Compare pricing, renewal costs, and included services.
                  </p>
                  {/* <img src={SolutionImages[4]} alt="loding step 3" /> */}
                </div>
              </div>
              <h3>Step 4: Selecting the Right Domain Name</h3>
              <div
                className={
                  Styles.HostingDomainSolutionSection2AnswerImagesContainer
                }
              >
                <div
                  className={
                    Styles.HostingDomainSolutionSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Keep it short, memorable, and relevant to your brand.
                  </p>

                  <p>
                    👉🏻 Use a .com extension for credibility, or niche-specific
                    extensions like .tech, .store, .online.
                  </p>
                  {/* <img src={SolutionImages[3]} alt="loding step 2" /> */}
                </div>
                <div
                  className={
                    Styles.HostingDomainSolutionSection2AnswerImgContainer
                  }
                >
                  <p>👉🏻 Avoid numbers, hyphens, and complex spellings.</p>
                  {/* <img src={SolutionImages[4]} alt="loding step 3" /> */}
                </div>
              </div>
              <h3>Step 5: Registering a Domain Name-</h3>
              <p>Watch this video:</p>
              <iframe
                className={Styles.HostingDomainSolutionSection2AnswerVideo1}
                src="https://www.youtube.com/embed/A6XlgQIcNQM?si=m3BNqHAIOyxaVc21"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
              <div
                className={
                  Styles.HostingDomainSolutionSection2AnswerImagesContainer
                }
              >
                <div
                  className={
                    Styles.HostingDomainSolutionSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Use a trusted domain registrar with transparent pricing.
                  </p>

                  <p>
                    👉🏻 Check for free WHOIS protection to secure your personal
                    information.
                  </p>
                  {/* <img src={SolutionImages[3]} alt="loding step 2" /> */}
                </div>
                <div
                  className={
                    Styles.HostingDomainSolutionSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Enable auto-renewal to prevent accidental expiration.
                  </p>
                  {/* <img src={SolutionImages[4]} alt="loding step 3" /> */}
                </div>
              </div>
              <h3>Step 6: Optimizing Hosting Performance</h3>
              <div
                className={
                  Styles.HostingDomainSolutionSection2AnswerImagesContainer
                }
              >
                <div
                  className={
                    Styles.HostingDomainSolutionSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Enable CDN (Content Delivery Network) to improve load
                    speeds.
                  </p>

                  <p>👉🏻 Use SSL certificates for security and better SEO.</p>
                  {/* <img src={SolutionImages[3]} alt="loding step 2" /> */}
                </div>
                <div
                  className={
                    Styles.HostingDomainSolutionSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Regularly update software and plugins to prevent
                    vulnerabilities.
                  </p>
                  {/* <img src={SolutionImages[4]} alt="loding step 3" /> */}
                </div>
              </div>
              <p>
                I hope you found this helpful! 👍✨ Don't forget to rate this
                blog!
              </p>
              <h3>HashTags</h3>
              <p>
                #WebHosting #DomainName #SecureHosting #FastWebsites
                #BestHostingProviders #WebsiteSpeed #ReliableHosting #SEOBoost
                #OnlineSuccess #TechSolutions
              </p>
              <h3>Keywords</h3>
              <p>
                web hosting solutions, best hosting providers, domain name
                registration, secure website hosting, reliable web hosting, VPS
                vs shared hosting, how to choose a domain name, website speed
                optimization, hosting security, cloud hosting benefits.
              </p>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default HostingDomainSolution;
